import { FC, memo } from "react";
import ReactPaginate from "react-paginate";
import { cn } from "@/lib/utils";
import { ArrowRight, ArrowLeft } from "lucide-react";

interface PaginateProps {
  className?: string;
  handlePageClick(event: { selected: number }): void;
  pageSelected: number;
  pageCount: number;
}

const Paginate: FC<PaginateProps> = ({
  className,
  handlePageClick,
  pageSelected,
  pageCount,
}: PaginateProps) => {
  return (
    <ReactPaginate
      className={cn("pagination", className)}
      breakLabel="..."
      nextLabel={<ArrowRight size={20} />}
      onPageChange={handlePageClick}
      pageRangeDisplayed={2}
      marginPagesDisplayed={2}
      pageCount={pageCount}
      previousLabel={<ArrowLeft size={20} />}
      renderOnZeroPageCount={null}
      activeClassName={"active"}
      containerClassName={"pagination"}
      pageClassName="pagination-item"
      disabledClassName="disabled"
      previousClassName="previous"
      nextClassName="next"
      breakClassName="break"
      forcePage={pageSelected - 1}
    />
  );
};
export default memo(Paginate);
